import Icon from '../../../components/AppIcon';

const PricingSection = () => {
  const handleTestClick = () => {
    window.open('https://t.me/Aidating_love7_bot?start=005_res', '_blank', 'noopener,noreferrer');
  };

  const handleDigitalTwinClick = () => {
    window.open('https://t.me/AppAIdating?start=006_res', '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="pricing" className="relative py-20 sm:py-32 bg-gradient-to-b from-background to-accent/5 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-1/4 text-pink-300/10 animate-float-slow">
          <Icon name="Heart" size={72} />
        </div>
        <div className="absolute bottom-32 right-1/4 text-red-300/10 animate-float">
          <Icon name="Sparkles" size={64} />
        </div>
      </div>

      <div className="relative max-w-content mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full text-accent text-sm font-medium mb-4">
            <Icon name="DollarSign" size={16} />
            <span>💳 Прайс aidating.love</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Наши продукты
          </h2>
          <p className="text-lg text-secondary max-w-2xl mx-auto">
            Два бесплатных продукта для поиска идеальной пары
          </p>
        </div>

        {/* Product 1: 7-Channel Test - FREE */}
        <div className="max-w-5xl mx-auto mb-8">
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 sm:p-8 border-2 border-green-300 shadow-lg">
            <div className="flex items-start gap-3 mb-6">
              <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Brain" size={24} color="#22c55e" />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-2xl font-bold text-foreground">
                    Тестирование 7 каналов мышления
                  </h3>
                  <div className="inline-block px-3 py-1 bg-green-500 text-white rounded-full text-sm font-bold">
                    БЕСПЛАТНО
                  </div>
                </div>
                <p className="text-secondary mb-4">
                  Узнайте, как вы воспринимаете мир и общаетесь с людьми. Пройдите полный тест на 7 каналов коммуникации.
                </p>
                <div className="bg-white/70 rounded-lg p-4 mb-4">
                  <p className="text-sm font-semibold text-foreground mb-2">Вы получите:</p>
                  <ul className="space-y-1.5">
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
                      <span>Полный профиль по 7 каналам коммуникации</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
                      <span>Детальные инструкции по подбору совместимого партнёра</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
                      <span>Анализ сильных и слабых зон общения</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
                      <span>Рекомендации по избежанию конфликтов</span>
                    </li>
                  </ul>
                </div>
                <button
                  onClick={handleTestClick}
                  className="w-full sm:w-auto px-8 py-4 bg-green-600 text-white rounded-lg font-bold text-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2 shadow-lg"
                >
                  <span>Пройти тест бесплатно</span>
                  <Icon name="ArrowRight" size={20} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Product 2: Digital Twin Creation - FREE */}
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 sm:p-8 border-2 border-purple-400 shadow-xl relative overflow-hidden">
            <div className="absolute top-4 right-4 px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full text-sm font-bold shadow-lg">
              ⭐ ПРЕМИУМ
            </div>
            <div className="flex items-start gap-3 mb-6">
              <div className="w-12 h-12 bg-purple-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Sparkles" size={24} color="#a855f7" />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-2xl font-bold text-foreground">
                    Создание цифрового двойника
                  </h3>
                  <div className="inline-block px-3 py-1 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full text-sm font-bold">
                    БЕСПЛАТНО
                  </div>
                </div>
                <p className="text-secondary mb-4">
                  Часовое видеоинтервью, создание вашего цифрового двойника и размещение в облаке для автоматического поиска наилучшей пары.
                </p>
                <div className="bg-white/70 rounded-lg p-4 mb-4">
                  <p className="text-sm font-semibold text-foreground mb-2">Что включено:</p>
                  <ul className="space-y-1.5">
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-purple-600 mt-0.5 flex-shrink-0" />
                      <span>Часовое видеоинтервью для глубокой оцифровки личности</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-purple-600 mt-0.5 flex-shrink-0" />
                      <span>Создание полного цифрового двойника с голосом и видео</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-purple-600 mt-0.5 flex-shrink-0" />
                      <span>Размещение двойника в облаке с другими участниками</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-purple-600 mt-0.5 flex-shrink-0" />
                      <span>Симуляция тысяч виртуальных свиданий</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-purple-600 mt-0.5 flex-shrink-0" />
                      <span>Предоставление лучшего совпадения (99,8%+ совместимость)</span>
                    </li>
                    <li className="flex items-start gap-2 text-sm text-secondary">
                      <Icon name="Check" size={16} className="text-purple-600 mt-0.5 flex-shrink-0" />
                      <span>Непрерывный поиск до нахождения идеальной пары</span>
                    </li>
                  </ul>
                </div>
                <button
                  onClick={handleDigitalTwinClick}
                  className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg font-bold text-lg hover:from-purple-700 hover:to-pink-700 transition-all flex items-center justify-center gap-2 shadow-xl"
                >
                  <span>Создать цифровой двойник</span>
                  <Icon name="ArrowRight" size={20} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Customer Journey Explanation */}
        <div className="max-w-5xl mx-auto mt-12 bg-gradient-to-br from-accent/5 to-primary/5 rounded-xl p-6 border border-border">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={24} className="text-primary flex-shrink-0 mt-1" />
            <div>
              <h4 className="text-lg font-bold text-foreground mb-2">Как это работает</h4>
              <p className="text-secondary text-sm leading-relaxed">
                <strong>Шаг 1:</strong> Пройдите бесплатное тестирование 7 каналов мышления, чтобы понять принцип работы каналов коммуникации и получить инструкции по подбору партнёра. <br/>
                <strong>Шаг 2:</strong> Создайте цифровой двойник бесплатно — ваш двойник автоматически найдёт наилучшую пару через симуляцию тысяч свиданий с совместимостью 99,8%+.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;